import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import {
  crowdfundingInsightOptions,
  crowdfundingNominatifAdministredOptions,
  crowdfundingNominatifPurOptions,
} from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'crowdfunding-settings',
    templateUrl: './crowdfunding-settings.component.html',
    styleUrls: ['./crowdfunding-settings.component.scss'],
    standalone: false
})
export class CrowdfundingSettingsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  pledge: PledgeRead;
  parameters: Parameters;
  crowdfundingNominatifPurOptions = crowdfundingNominatifPurOptions;
  crowdfundingNominatifAdministredOptions =
    crowdfundingNominatifAdministredOptions;
  crowdfundingInsightOptions = crowdfundingInsightOptions;

  CROWDFUNDING_NOMINATIF_PUR = CompanyFieldType.CROWDFUNDING_NOMINATIF_PUR;

  CROWDFUNDING_INSIGHT_CHOICE = CompanyFieldType.CROWDFUNDING_INSIGHT_CHOICE;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.parameters = this.pledge?.parameters;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
    return this.products
      .get(`${0}`)
      .get('crowdfundingNominatifPur')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(data => {
        const nominatifAdministredControl = this.products
          .get(`${0}`)
          .get('crowdfundingNominatifAdministredOption');
        if (data === 'ADMINISTRED') {
          nominatifAdministredControl.setValidators([Validators.required]);

          nominatifAdministredControl.updateValueAndValidity();
        } else {
          nominatifAdministredControl.setValue(null);
          nominatifAdministredControl.setValidators([Validators.nullValidator]);

          nominatifAdministredControl.updateValueAndValidity();
        }
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
